import React from 'react';
import { useHistory } from 'react-router-dom';

// utils
// settings
// icons
// components
//
//
//
import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
//
//
import BodyRow from 'modules/emergencies/components/ui/rows/bodyRow';
import { NameColumn } from '../columns/NameColum';
import styled from 'styled-components';
import { RatingColumn } from '../columns/RatingColumn';
import { WorkingAreasColumn } from '../columns/WorkingAreasColumn';
import { ExternalIdColumn } from '../columns/ExternalIdColumn';

const CustomStartColumnsContainer = styled(StartColumnsContainer)`
  width: 100%;
`;
const CustomBodyRow = styled(BodyRow)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  padding-top: 16px;
  padding-bottom: 16px;
`;

const CarrierListTableCarrierRow = ({ carrier }) => {
  const carrier_id = carrier.id;
  const history = useHistory();

  const onBodyRowClick = () => {
    history.push(`/carrier/${carrier_id}/edit`);
  };

  return (
    <>
      <CustomBodyRow
        key={carrier.id}
        onClick={() => {
          onBodyRowClick();
        }}
      >
        <CustomStartColumnsContainer>
          <NameColumn carrier={carrier} />
          <ExternalIdColumn carrier={carrier} />
          <WorkingAreasColumn carrier={carrier} />
          <RatingColumn carrier={carrier} />
        </CustomStartColumnsContainer>
      </CustomBodyRow>
    </>
  );
};

export default CarrierListTableCarrierRow;
